import MenuItem from './MenuItem'

const MenuItemWithSubItems = ({menuItem, pages, homePages, overviewPages, currentCinema }) => { 
    if(_.has(menuItem, 'children') === true) {
        const { children } = menuItem

        const itemChildrenList = children.map((childItem, index) => {
            return (
                <li key={index} className={"child-item-list item-list gap-20"}>
                    <MenuItem
                        menuItem={childItem}
                        pages={pages}
                        homePages={homePages}
                        overviewPages={overviewPages}
                        currentCinema={currentCinema}
                    />
                </li>
            )
        })

        return (
            <li className={"item-list gap-30"}>
                <MenuItem
                    menuItem={menuItem}
                    pages={pages}
                    homePages={homePages}
                    overviewPages={overviewPages}
                    currentCinema={currentCinema}
                    />

                <ul className="child-item-list">
                    {itemChildrenList}
                </ul>
            </li>
        )
    } else {
        return (
            <li className={"item-list gap-30"}>
                <MenuItem
                    menuItem={menuItem}
                    pages={pages}
                    homePages={homePages}
                    overviewPages={overviewPages}
                    currentCinema={currentCinema}
                />
            </li>
        )
    }
} 

export default MenuItemWithSubItems